//ASSETS
import collapsableUpIcon from "../../assets/images/icons/ui/arrows/collapsable-up.svg";
import collapsableDownIcon from "../../assets/images/icons/ui/arrows/collapsable-down.svg";

const CollapsableArrow = ({ isOpen }: { isOpen: boolean }) => {
  return (
    <>
      {isOpen ? (
        <img src={collapsableUpIcon} alt="Collapsable Up Icon" />
      ) : (
        <img src={collapsableDownIcon} alt="Collapsable Down Icon" />
      )}
    </>
  );
};

export default CollapsableArrow;
